import React, {ChangeEvent, useState} from 'react'
import {Checkbox, FormControl, FormControlLabel, InputAdornment} from '@mui/material';
import {ICheckBoxInput} from './interfaces';
import {CheckBoxFlex, CheckBoxFullWidth} from './styles';

const formatIcons = (icon: React.ReactNode, checkedIcon: React.ReactNode) => {
  if (icon && checkedIcon) {
    return {
      icon: <InputAdornment position="start">{icon}</InputAdornment>,
      checkedIcon: <InputAdornment position="start">{checkedIcon}</InputAdornment>
    };
  }
  return {};
}

/**
 * Render a checkbox input
 * @param props
 * @constructor
 */
const CheckBoxInput = (props: ICheckBoxInput) => {
  const {
    name = "",
    label = "",
    value = false,
    required = false,
    disabled = false,
    icon = null,
    checkedIcon = null,
    onChange,
  } = props;

  const [checked, setChecked] = useState<boolean | undefined>(value);

  const handleChange = (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setChecked(checked);
    if (onChange) {
      onChange(event);
    }
  }

  return (
    <CheckBoxFlex item>
      <CheckBoxFullWidth item>
        <FormControl variant='standard' fullWidth>
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                color="secondary"
                {...formatIcons(icon, checkedIcon)}
                onChange={handleChange}
              />
            }
            label={label}
            required={required}
            disabled={disabled}
            name={name}
          />
        </FormControl>
      </CheckBoxFullWidth>
    </CheckBoxFlex>
  )
}

export default CheckBoxInput;
